import { EMP_INFO_SYSTEM_NAME } from '../constants/StandardEmploymentInformationSystemName.js';
import type { TaetigkeitsBaseData } from './TaetigkeitsBaseData.js';

export const Schulabschluss = [
  {
    [EMP_INFO_SYSTEM_NAME]: 4,
    Bezeichnung: 'Abitur / Fachabitur',
  },
  {
    [EMP_INFO_SYSTEM_NAME]: 9,
    Bezeichnung: 'Abschluss unbekannt',
  },
  {
    [EMP_INFO_SYSTEM_NAME]: 2,
    Bezeichnung: 'Haupt-/Volksschulabschluss',
  },
  {
    [EMP_INFO_SYSTEM_NAME]: 3,
    Bezeichnung: 'Mittlere Reife oder gleichwertiger Abschluss',
  },
  {
    [EMP_INFO_SYSTEM_NAME]: 1,
    Bezeichnung: 'Ohne Schulabschluss',
  },
] satisfies TaetigkeitsBaseData;
